import { untrack } from 'svelte'
import { createEventDispatcher } from 'svelte'
import { detectedEnv } from '#app/lib/env_config'

export function BubbleUpComponentEvent (dispatch?: ReturnType<typeof createEventDispatcher>) {
  dispatch = dispatch || createEventDispatcher()
  return e => {
    if (e instanceof CustomEvent) {
      // Re-dispatch an identical custom event
      dispatch(e.type, e.detail)
    } else {
      // 'e' is expected to be a DOM event
      // Dispatch the event object as event detail to make its attributes,
      // such as its `target` accessible to parent components
      dispatch(e.type, e)
    }
  }
}

// Use to make reactive statements code more explicit:
// Ex: allows to replace:
//     $: someVariable != null && doSomething()     // Not possible for variables that could actually == null
//     $: if (someVariable != null) doSomething()   // Not possible for variables that could actually == null
//     $: if (someVariable || true) doSomething()
// with:
//     $: onChange(someVariable, doSomething)
//     $: onChange(someVariable, someOtherVariable, doSomething)
// The syntax is tought to invite wrapping other variables
// for which we should NOT watch for change in the callback,
// so that they don't trigger the reactive execution
export function onChange (...args) {
  const callback = args.slice(-1)[0]
  untrack(callback)
}

/**
 * A noop function with only purpose to declare which pieces of state
 * should be considered a state dependency by an $effect or $derived rune.
 * Its name is meant to reflect that it has the opposite function of Svelte `untrack`.
 * See https://svelte.dev/docs/svelte/$effect#Understanding-dependencies
 * and https://svelte.dev/docs/svelte/svelte#untrack
*/
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function track (...args: unknown[]) {}

export function initSvelteWarningFilter () {
  if (detectedEnv !== 'prod') {
    const originalWarn = globalThis.console.warn
    globalThis.console.warn = function (...args) {
      if (args[0].includes('ownership_invalid_binding') && args[0].includes('app_layout.svelte')) {
        // Silence ownership_invalid_binding warning about the AppLayout not binding to its children components
        return
      }
      originalWarn(...args)
    }
  }
}
